import * as React from "react"

function MoveIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
            <path stroke="currentColor" opacity={0.3} strokeLinecap="round" strokeWidth={2} d="M16 11v2m0 8v-2m5-3h-2m-8 0h2" />
            <path fill="currentColor" d="M15.571 4.715a.5.5 0 0 1 .858 0l2.117 3.528a.5.5 0 0 1-.43.757h-4.233a.5.5 0 0 1-.429-.757l2.117-3.528ZM27.285 15.571a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43v-4.233a.5.5 0 0 1 .757-.429l3.528 2.117ZM15.571 27.285a.5.5 0 0 0 .858 0l2.117-3.528a.5.5 0 0 0-.43-.757h-4.233a.5.5 0 0 0-.429.757l2.117 3.528ZM4.715 15.571a.5.5 0 0 0 0 .858l3.528 2.117a.5.5 0 0 0 .757-.43v-4.233a.5.5 0 0 0-.757-.429l-3.528 2.117Z" />
        </svg>
    );
}

export default MoveIcon;
